const TaskMessage = React.memo(function TaskMessage(props){
    const {
        value,
        onChange,
    } = props;

    const change = React.useCallback((name, value) => {
        onChange(name, value);
    }, []);

    //useRenderDebug('TaskMessage', {props});

    return (
        <div className={`processes-task-message flex-vertical`}>
            <TaskField
                type={'text'}
                label={'Subject'}
                name={'task_subject'}
                value={value.task_subject || ''}
                onChange={change}
            />
            <TaskField
                type={'html'}
                name={'task_message_body'}
                label={'Body'}
                required={true}
                value={value.task_message_body || ''}
                rows={10}
                onChange={change}
            />
        </div>
    );
});

TaskMessage.defaultProps = {
    value: PropTypes.any,
    onChange: PropTypes.func,
};

TaskMessage.defaultProps = {
    value: {},
    onChange: (path, value) => {},
};
TaskMessage.displayName = 'TaskMessage';